import {List, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {px} from '../../../../utils';
import {renderIfElse} from '../../../../utils/Utils';
import CustomCard from './CustomCard';

const CardsList = ({data}) => {
  const renderItem = ({item, index}) => <CustomCard key={index} data={item} />;

  return (
    <View>
      {renderIfElse(
        data && data.length > 0,
        <List
          contentContainerStyle={styles.contentContainer}
          data={data}
          renderItem={renderItem}
        />,
        <Text style={styles.noClassText}>No data found</Text>,
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  noClassText: {
    textAlign: 'center',
    marginTop: px(30),
    fontSize: px(22),
  },
  contentContainer: {
    paddingHorizontal: px(17),
    paddingTop: px(17),
    backgroundColor: 'white',
  },
});

export default CardsList;
